import React, { ReactElement } from 'react';
import { observer } from 'src/utils/mobx-react';
import Header from 'src/components/Header';
import { LayoutWrapper, MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';
import { BonusEngineContent } from './BonusEngineContent';
import { useAppStateContext } from 'src/AppState/AppState';
import { BONUS_ENGINE_ROOT } from 'src/domains/casino/utils/test-variables';
import { MenuItemsType } from 'src/components/Header/LHSMenu/SideMenu/SideMenu';
import CustomersBar from 'src/components/CustomersBar';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { Permission } from 'src/AppState/PermissionGrants/PermissionGrants.types';

export const BonusEnginePage = observer('BonusPage', (): ReactElement => {
    const { routerBackoffice, permissionGrantsState } = useAppStateContext();

    const common = useCommon();
    const configState = ConfigState.get(common);
    const { showBonusEngine, showBonusCreator } = configState.config;

    const hasBonusEnginePermission = permissionGrantsState.has(Permission.bonusEngineManageBonuses);

    if (showBonusEngine === false || hasBonusEnginePermission === false) {
        routerBackoffice.redirectToGlobal();
    }

    const menuItems: Array<MenuItemsType> = [
        {
            id: 'campaign-list',
            label: 'Campaign List',
            onClick: (): void => routerBackoffice.redirectToBonusCampaignList(),
            activeParams: ['campaign-list', 'edit-campaign', 'new-campaign'],
        },
        // Calendar and Analytics page will be designed and developed in future
        // {
        //     id: 'calendar',
        //     label: 'Calendar',
        //     onClick: (): void => routerBackoffice.redirectToBonusCalendar(),
        // },
        // {
        //     id: 'analytics',
        //     label: 'Analytics',
        //     onClick: (): void => routerBackoffice.redirectToBonusAnalytics(),
        // },
    ];

    if (showBonusCreator === true) {
        menuItems.push({
            id: 'bonus-creator',
            label: 'Bonus List',
            onClick: (): void => routerBackoffice.redirectToBonusCreator(),
            activeParams: ['bonus-creator', 'edit-bonus-creation', 'new-bonus-creation'],
        });
    }

    return (
        <LayoutWrapper>
            <MainContainer data-test={BONUS_ENGINE_ROOT}>
                <Header sideLinks={menuItems} />
                <BonusEngineContent />
            </MainContainer>
            <CustomersBar />
        </LayoutWrapper>
    );
});
